import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Home, Detail, PageNotFound } from 'pages';
import { strings } from 'config';

class Router extends Component {
  state = {};

  componentWillMount(){
    strings.setLanguage('np');
  }

  render() {
    return (
      <BrowserRouter>
        <div>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/detail/:id" component={Detail} />
            <Route component={PageNotFound}></Route>
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default Router;



// WEBPACK FOOTER //
// ./src/router.js